import { useEffect } from "react";
import { I18nProvider } from "./i18n";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Calculator from "./components/Calculator";
import CaraKerja from "./components/CaraKerja";
import Bento from "./components/Bento";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

function App() {
    useEffect(() => {
        let lenis;
        let rafId;
        let cancelled = false;
        let cleanup = () => {};

        import("lenis")
            .then(({ default: Lenis }) => {
                if (cancelled) return;
                lenis = new Lenis({ lerp: 0.1, anchors: true });
                const raf = (t) => {
                    lenis.raf(t);
                    rafId = requestAnimationFrame(raf);
                };
                rafId = requestAnimationFrame(raf);
                cleanup = () => {
                    cancelAnimationFrame(rafId);
                    lenis.destroy();
                };
            })
            .catch(() => {});
        return () => {
            cancelled = true;
            cleanup();
        };
    }, []);

    return (
        <I18nProvider>
            <div className="relative">
                <div className="noise-overlay" aria-hidden="true" />
                <Navbar />
                <main>
                    <Hero />
                    <Marquee />
                    <Calculator />
                    <CaraKerja />
                    <Bento />
                    <Faq />
                </main>
                <Footer />
            </div>
        </I18nProvider>
    );
}

export default App;
